import { getByMobileNumber } from "./api.ts";

// Look a guest up by mobile number on the server. The guest list screens only load
// one page of guests, so searching that list misses everyone on later pages.
export const lookupGuestByMobile = async (mobile) => {
  try {
    const response = await getByMobileNumber(mobile, {});
    const g = response?.success ? response.data : null;
    if (!g || g.guest_id == null) return null;
    const name = [g.first_name, g.middle_name, g.last_name].filter(Boolean).join(" ");
    return { guest_id: g.guest_id, name };
  } catch (error) {
    return null;
  }
};
